import React from "react";
import { ButtonSingle } from "../../../../../widget/common/form/Button";
import AppTranslation from "../../../../../service/app_translation/AppTranslation";
import { SignupAccountVerificationContextImport } from "../../../../../provider/onboarding/signup/account_verification/SignupAccountVerificationContextProvider";

const SignupAccountVerificationChangeButtons = (props: {
  type?: number | undefined;
}) => {
  const { submitChangeEmailPhone } = SignupAccountVerificationContextImport();

  return (
    <ButtonSingle handleClick={submitChangeEmailPhone} width={300}>
      {AppTranslation.text("save")}
    </ButtonSingle>
  );
};

export default SignupAccountVerificationChangeButtons;
